module.exports = __webpack_public_path__ + "static/thammasat-university-aadbcf7f2834fae47ec571e64effadd0.png";